import { ISelectOptions } from "../../../types/inputs";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import * as S from "./styles";
import { useFormDeliveryRescheduling } from "./useFormDeliveryRescheduling";
import { ComponentProps, useEffect } from "react";
import {
  IAgendamentoAlterarTipoFormRHF,
  IAgendamentoDTO,
} from "../../../types/agendamento";
import { Text } from "../../Atoms/Text";
import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { Info } from "../../Atoms/Info";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { InputDate } from "../../Atoms/Inputs/InputDate";
import dayjs from "dayjs";

interface IFormDeliveryReschedulingProps extends ComponentProps<"form"> {
  submitForm: (data: IAgendamentoAlterarTipoFormRHF) => void;
  data?: IAgendamentoDTO;
}

export const FormDeliveryRescheduling = ({
  submitForm,
  data,
  ...rest
}: IFormDeliveryReschedulingProps) => {
  const {
    cidadesOptions,
    localOptions,
    Controller,
    control,
    handleSubmit,
    watch,
    concessionarias,
    register,
    handleCep,
    cidadesformOptions,
    ufOptions,
    navidate,
    setValue,
    diasIndisponiveis,
    horariosOptions,
    isLoading,
  } = useFormDeliveryRescheduling();

  useEffect(() => {
    setValue("uuidDelivery", data?.delivery?.uuid);
    setValue("concessionaria", data?.tipoAtendimento);
  }, [data]);

  return (
    <>
      <S.Form {...rest} onSubmit={handleSubmit(submitForm)}>
        <S.FlexWrapper>
          <div>
            <Controller
              control={control}
              name="uuidDelivery"
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  options={cidadesOptions}
                  label="Cidade"
                  required
                  onChange={(e: ISelectOptions) => onChange(e?.value)}
                  value={
                    cidadesOptions.find((item) => item.value === value) || null
                  }
                />
              )}
            />
          </div>
          <div>
            <Controller
              control={control}
              name="concessionaria"
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  options={localOptions}
                  isDisabled={!!data?.delivery?.uuid}
                  value={
                    localOptions.find((item) => item.value === value) || null
                  }
                  label="Local de Atendimento"
                  required
                  onChange={(e: ISelectOptions) => onChange(e?.value)}
                />
              )}
            />
          </div>
        </S.FlexWrapper>
        <S.FlexWrapper>
          <div>
            <Controller
              control={control}
              name="diaAgendado"
              render={({ field: { onChange, value } }) => (
                <InputDate
                  showIcon
                  isLoading={isLoading}
                  minDate={new Date()}
                  label="Data"
                  required
                  disabled={!watch("uuidDelivery")}
                  excludeDates={diasIndisponiveis}
                  onChange={(e) => {
                    onChange(dayjs(e).format("YYYY-MM-DD"));
                  }}
                  placeholderText="__/__/__"
                  selected={value && dayjs(value).toDate()}
                />
              )}
            />
          </div>
          <div>
            <Controller
              control={control}
              name="horaAgendada"
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  label="Horário"
                  isDisabled={!watch("diaAgendado")}
                  value={
                    horariosOptions?.find((item) => item.value === value) ||
                    null
                  }
                  onChange={(e: ISelectOptions) => onChange(e?.value)}
                  options={horariosOptions}
                  required
                />
              )}
            />
          </div>
        </S.FlexWrapper>

        {watch("concessionaria") === "DOMICILIO" && (
          <div>
            <S.GridWrapper>
              <div>
                <Text>Endereço de Realização do Serviço</Text>
              </div>
              <div>
                <Input required label="Nome" {...register("nome")} />
              </div>

              <div>
                <Input
                  required
                  maxLength={15}
                  label="Telefone"
                  {...register("telefone")}
                />
              </div>

              <div>
                <Input
                  {...register("endereco.cep")}
                  required
                  maxLength={9}
                  label="CEP"
                  onBlur={handleCep}
                />
              </div>

              <div>
                <Input
                  label="Endereço (Rua)"
                  required
                  {...register("endereco.logradouro")}
                />
              </div>

              <div>
                <Input
                  label="Número"
                  required
                  type="number"
                  {...register("endereco.numero")}
                />
              </div>

              <div>
                <Input
                  label="Complemento"
                  {...register("endereco.complemento")}
                />
              </div>

              <div>
                <Input
                  label="Bairro"
                  required
                  {...register("endereco.bairro")}
                />
              </div>

              <div>
                <Controller
                  control={control}
                  name="endereco.uf"
                  render={({ field: { onChange, value } }) => (
                    <SimpleSelect
                      placeholder=""
                      label="UF"
                      required
                      options={ufOptions}
                      value={ufOptions.find((_) => _.value === value) || null}
                      onChange={(e: ISelectOptions) => onChange(e.value)}
                    />
                  )}
                />
              </div>

              <div>
                <Controller
                  control={control}
                  name="endereco.cidade"
                  render={({ field: { onChange, value } }) => (
                    <SimpleSelect
                      required
                      label="Cidade"
                      placeholder=""
                      key={`${Math.random()} - ${watch("endereco.uf")}`}
                      options={cidadesformOptions}
                      value={
                        cidadesformOptions.find((_) => _.value === value) ||
                        null
                      }
                      onChange={(e: ISelectOptions) => onChange(e.value)}
                    />
                  )}
                />
              </div>
            </S.GridWrapper>
          </div>
        )}
        {watch("concessionaria") === "CONCESSIONARIA" && (
          <S.GridItem>
            <div>
              <Text>Endereço de Realização do Serviço</Text>
            </div>

            <div>
              <Input required label="Nome" {...register("nome")} />
            </div>

            <div>
              <Input
                required
                maxLength={15}
                label="Telefone"
                {...register("telefone")}
              />
            </div>
            <div>
              <Controller
                control={control}
                name="uuidConcessionaria"
                render={({ field: { onChange, value } }) => (
                  <SimpleSelect
                    options={concessionarias}
                    label="Concessionária"
                    required
                    onChange={(e: ISelectOptions) => {
                      onChange(e?.value);
                    }}
                    value={
                      concessionarias.find((i) => i.value === value) || null
                    }
                  />
                )}
              />
            </div>
          </S.GridItem>
        )}

        <div>
          <Button data-variant-text type="button" onClick={() => navidate(-1)}>
            Voltar
          </Button>
          <Button>Salvar</Button>
        </div>
      </S.Form>

      <S.WrapperInfos>
        {watch("concessionaria") ? (
          <Info
            required
            text="O local de realização do agendamento é de responsabilidade o cliente. Evite vias públicas!"
          />
        ) : null}

        {watch("concessionaria") ? (
          <Info
            required
            text="Os valores dos serviços podem variar, e o ajuste deve ser pago pelo cliente antes de confirmar o novo agendamento."
          />
        ) : null}
      </S.WrapperInfos>
    </>
  );
};
